<script>
  import { TheMask } from "vue-the-mask"
  import { resendConfirmation } from "@/domains/auth/services"

  export default {
    components: {
      TheMask,
    },
    props: {
      document: { type: String, default: "" },
    },
    data() {
      return {
        input: "",
        status: "pending",
        message: null,
        errors: null,
      }
    },
    mounted() {
      this.input = this.document
    },
    methods: {
      send() {
        this.$Progress.start()
        this.errors = null
        this.status = "pending"
        resendConfirmation(this.input)
          .then((response) => {
            this.$toast.success({
              title: "OK",
              message: response,
            })
            this.message = response
            this.status = "finished"
            this.$Progress.finish()
          })
          .catch((e) => {
            if (e.status !== 422) {
              this.$toast.error({
                message: e.error,
              })
            } else {
              this.errors = e.error
            }
            if (e.status === 403) {
              this.status = "no-email"
            } else {
              this.status = "rejected"
            }
            this.$Progress.finish()
          })
      },
    },
  }
</script>

<template>
  <form @submit.prevent="send">
    <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
      <div class="sm:flex sm:items-start">
        <div
          :class="[
                        status === 'finished' ? 'bg-green-100' : 'bg-red-100',
                        'mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10'
                    ]"
        >
          <svg
            v-if="status === 'finished'"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="h-6 w-6 text-green-600"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76"
            />
          </svg>
          <svg
            v-else
            class="h-6 w-6 text-red-600"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3 class="text-lg leading-normal font-medium text-gray-900">
            <span v-if="status === 'finished'">E-mail enviado</span>
            <span v-else>Reenviar confirmação de cadastro</span>
          </h3>
          <div class="mt-2">
            <p
              v-if="status === 'finished'"
              class="text-left text-sm leading-tight text-gray-dark"
            >
              {{ message }}
            </p>
            <p v-else class="text-left text-sm leading-tight text-gray-500">
              Digite o seu CPF ou CNPJ abaixo e clique em enviar. A confirmação
              de cadastro será reenviada para o seu e-mail cadastrado em nossa
              base.
            </p>
          </div>
          <div v-if="status !== 'finished'" class="mt-3 sm:mt-2">
            <TheMask
              class="form-input w-full"
              :mask="['###.###.###-##', '##.###.###/####-##']"
              placeholder="000.000.000-00"
              v-model="input"
              v-focus
              required
            />
            <div v-if="errors && errors.document">
              <p
                v-for="(error, index) in errors.document"
                v-bind:key="index"
                class="italic text-red-base text-xs"
              >
                {{ error }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-gray-100 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
      <span
        v-if="status !== 'finished'"
        class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
      >
        <button
          type="submit"
          class="uppercase inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-xs leading-normal font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:leading-tight"
        >
          Enviar
        </button>
      </span>
      <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <button
          @click="$emit('close')"
          type="button"
          class="uppercase inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-xs leading-normal font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-green-300 focus:shadow-outline transition ease-in-out duration-150 sm:leading-tight"
        >
          <span v-if="status === 'finished'">Fechar</span>
          <span v-else>Cancelar</span>
        </button>
      </span>
    </div>
  </form>
</template>
